module.exports = __webpack_public_path__ + "static/img/step-1023.5bb6011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-1023.png
// module id = 3/n0
// module chunks = 1